import { MarketingMessage } from './MarketingMessage';
import icon_ev from '../../assets/icon_ev_empty_state.svg';

export const MarketingMessageEv = () => {
  return (
    <MarketingMessage heading="EV Charging" icon={icon_ev} showContact={true}>
      <>
        <p>
          If you are considering adding EV charging equipment to your facility,{' '}
          <strong>please contact Elexity first</strong>
        </p>
        <p>
          EV charging can have a significant impact on your utility bill, and Elexity has helped
          other customers mitigate cost increases with smart charging strategies and integration
          with our control software.{' '}
        </p>
        <p>We can help you select equipment that allows such control if you are interested.</p>
      </>
    </MarketingMessage>
  );
};
